// @see https://ikyu.atlassian.net/browse/RES-475

export function mask(err: Error): Error {
  const masked = new Error(maskMessage(err.message))
  if (err.stack !== undefined) {
    masked.stack = maskMessage(err.stack)
  }
  return masked
}

// @see https://github.com/ikyucom/member/blob/270dd91316390ea230c1d7c056214b186be6c930/pkg/error/utility.go#L5-L6
const mailAddresses =
  /[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*/
const phoneNumbers = /0[5-9]0[0-9]{8}/

const piiPatterns = [mailAddresses, phoneNumbers]

export function maskMessage(message: string): string {
  return isPIILeakSuspected(message) ? '[REDACTED] PII Leak suspected message' : message
}

function isPIILeakSuspected(message?: string): boolean {
  if (message === undefined) {
    return false
  }
  return piiPatterns.some((p) => p.test(message))
}

if (import.meta.vitest) {
  const { it, describe, expect } = import.meta.vitest

  describe('mask', () => {
    it('PIIを含むエラーをマスクする', () => {
      const err = new Error('email test@example.com test')
      const masked = mask(err)
      expect(masked.message).toBe('[REDACTED] PII Leak suspected message')
      expect(masked.stack).toBe('[REDACTED] PII Leak suspected message')
    })

    it('PIIを含まないエラーをマスクしない', () => {
      const err = new Error('test')
      err.stack = 'test'
      const masked = mask(err)
      expect(masked.message).toBe('test')
      expect(masked.stack).toBe('test')
    })
  })

  describe('maskMessage', () => {
    it('PIIを含む文字列をマスクする', () => {
      expect(maskMessage('email test@example.com test')).toBe(
        '[REDACTED] PII Leak suspected message'
      )
      expect(maskMessage('phone number 06012345678 test')).toBe(
        '[REDACTED] PII Leak suspected message'
      )
    })

    it('PIIを含まない文字列をマスクしない', () => {
      expect(maskMessage('test')).toBe('test')

      // 携帯電話番号の桁数に満たない
      expect(maskMessage('phone number 0600012345 test')).toBe('phone number 0600012345 test')
    })
  })
}
